module.exports = __webpack_public_path__ + "static/img/vip-read.dec48ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vip-read.png
// module id = k/4V
// module chunks = 1